import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

interface MassiveAction {
  title: string;
  description: string;
  route: string;
}

@Component({
  selector: 'app-home',
  imports: [CommonModule],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  massiveActions: MassiveAction[] = [
    {
      title: 'Subida masiva de notas simples',
      description: 'Con esta herramienta puedes subir notas simples a múltiples expedientes cargando un fichero CSV con la información necesaria',
      route: '/massive-upload'
    },
    {
      title: 'Generacion ficheros AC/TF y tasaciones Ibercaja',
      description: 'Con esta herramienta puedes generar los ficheros AC/TF y ficheros de tasaciones para Ibercaja cargando un fichero CSV con los IDs de tasación',
      route: '/ibercaja-upload'
    },
    {
      title: 'Altas masivas relación 1-N',
      description: 'Con esta herramienta puedes realizar altas masivas de relación 1-N cargando un fichero Excel con los ítems a procesar',
      route: '/massive-services-upload'
    },
    {
      title: 'Altas masivas relación 1-1',
      description: 'Con esta herramienta puedes realizar altas masivas de relación 1-1 cargando un fichero Excel con los ítems a procesar',
      route: '/massive-services2-upload'
    },
    {
      title: 'Carga de valores antecedentes backtesting',
      description: 'Con esta herramienta puedes cargar valores antecedentes para backtesting cargando un fichero Excel con los datos necesarios',
      route: '/antecedent-value-check-upload'
    },
    {
      title: 'Carga masiva de controles de calidad externos',
      description: 'Con esta herramienta puedes realizar una carga masiva de controles de calidad externos cargando un fichero Excel con los datos necesarios',
      route: '/external-quality-control-upload'
    }
  ];

  constructor(private router: Router) {}

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
